import {
    CONTACT_LIST_REQUEST,
    CONTACT_LIST_SUCCESS,
    CONTACT_LIST_FAIL,
    CONTACT_DELETE_REQUEST,
    CONTACT_DELETE_SUCCESS,
    CONTACT_DELETE_FAIL,
    CLEAR_ERRORS
  } from "../../constants/admin/contactConstants";
  
  const initialState = {
    contacts: [],
    loading: false,
    error: null,
  };
  
  export const contactListReducer = (state = initialState, action) => {
    switch (action.type) {
      case CONTACT_LIST_REQUEST:
        return { ...state, loading: true };
      case CONTACT_LIST_SUCCESS:
        return { ...state, loading: false, contacts: action.payload };
      case CONTACT_LIST_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      case CONTACT_DELETE_REQUEST:
        return { ...state, loading: true };
      case CONTACT_DELETE_SUCCESS:
        return {
          ...state,
          loading: false,
          contacts: state.contacts.filter((contact) => contact._id !== action.payload),
        };
      case CONTACT_DELETE_FAIL:
        return { ...state, loading: false, error: action.payload };
  
        case CLEAR_ERRORS:
              return {
                ...state,
                error: null,
              };
              
      default:
        return state;
    }
  };
  